/**
 * Module de commentaires
 * @version du 25/01/2019 11:25:37
 * @author SD 2018
 */
"use strict";

if(moment !== undefined ) {
  moment.locale('fr');
}

Vue.component('commentaire-comp', {
    template: `
        <div class="comment__wrapper">
          <div class="comment__content">
            <p class="commentaire__author"><span class="text-muted">Posté par :</span> {{ commentaire.NameUserMAJ }} <span class="badge badge-light"><i class="fa fa-calendar-o"></i> {{ comment_date(commentaire.DateMAJ) }}</span></p>
            <div class="commentaire__body">{{ commentaire.Body }}</div>
          </div>
          <div class="comment__actions" >
          <a href="#" title="Editer le commentaire" @click.prevent="$emit('comment_edit',commentaire.IdCommentaire)" class="btn btn-info btn-sm" v-if="user.idUser == commentaire.IdUserMAJ">
              <i class="fa fa-edit fa-fw"></i></a>
              <a href="#" title="effacer le commentaire" @click.prevent="$emit('comment_delete',commentaire.IdCommentaire)" class="btn btn-danger btn-sm" v-if="user.idUser == commentaire.IdUserMAJ || user.isAdmin"> <i class="fa fa-trash fa-fw"></i></a>
          </div>
        </div>
    `,
  props: {
    commentaire: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    comment_date: function (dateC) {
      return moment(dateC, "DD/MM/YYYY HH:mm:ss").fromNow();
    },
    comment_edit: function (id) {
      console.info('Edit');
    }
  }
}); // fin du composant 'comment'

let vue = new Vue({
  el: "#module__commentaires",

  // =========================
  //
  // state de l'application
  //
  // =========================
  data: {
    config: {
      urlWebServices: "/modules/commentaires/wsCommentaires.asmx/"
    },
    
    
    page: {
      showCommentModule: false,
      commentaires: [],
      likes: [],
      hero: "hero",
      
      isCommentsLoaded: false, // le chargement des commentaires de départ a-t-il bien eu lieu ?
      noComment: true, //
      isLikesLoaded: false, // le chargement des likes de départ a-t-il bien eu lieu ?
      hasCommentaires: false, // des commentaires à afficher ?
    },
    
    
    user: {
      isIdentified: false, // l'utilisateur est-il connu ?
      nom: null,
      idUser: null,
      isAdmin: false,
      liked: false, // par défaut la personne n'aime pas la page
      userComment:"", // binding du champs de saisie des commentaire
      isEdit: false, // est-on en train d'éditer un commentaire existant ?
      editId: null, // id du commentaire existant que l'on édite
      localId: null // index local du commentaire édité
    }
  },
  
  // ==========================
  // méthodes de l'application
  // ==========================
  methods: {
    /**
     * @description méthode générique d'appel au webservices
     * @param webService
     * @param params
     * @return {promise}
     */
    webService: function (webService, params) {
      params = params || {};
      
      return $.ajax({
        url: webService,
        data: params,
        type: 'POST',
        dataType: "json",
        contentType: "application/json; charset=utf-8"
      }).promise();
    }, // fin  methode webService
  
    /**
     * @description formatage de la date d'un commentaire
     * @param id
     * @return string
     */
    dateCommentaire: function(localId) {
      return moment(this.page.commentaires[localId].DateMAJ, "DD/MM/YYYY HH:mm:ss").format("LLL");
    },
  
    /**
     * @description provoque l'abandon de l'édition d'un commentaire
     * @version 0.1
     */
    cancelEdit: function() {
      this.user.userComment = "";
      this.user.isEdit = false;
      $('.commentaire__form').removeClass('hero');
    },
  
    /**
     * @description récupération des données utilisateur courant et des commentaires
     * @version 0.9
     */
    getComments: function() {
      const _this = this; // utilis si la méthode est appelée depuis un hook
      // récupération des commentaires depuis le webservice
      
      this.webService(_this.config.urlWebServices + 'getComments').then(
        (response) =>  {
          console.info("WS getComments");
          
          let jdata = $.parseJSON(response.d);
          
          console.dir(jdata);
          
          if (jdata.Data === null || _.isEmpty(jdata.Data)) {
            console.warn("Pas de commentaires");
            _this.isLoaded = true;
            _this.page.isCommentsLoaded = false;
            _this.page.noComment = true;
            
          } else {
            console.info("Y'a des commentaires");
            let wsData = $.parseJSON(jdata.Data);
            
            // binding du user
            if(!_.isEmpty(wsData.User)) {
              _this.user.isAdmin = wsData.User.IsAdmin;
              _this.user.idUser= wsData.User.IdUser;
              _this.user.nom = wsData.User.UserName;
              _this.user.isIdentified = true;
            }
            
            //binding des commentaires
            _this.page.commentaires = wsData.Comments;
            _this.page.commentaires = _.sortBy(_this.page.commentaires, 'date').reverse();
            _this.page.isCommentsLoaded = true;
            _this.page.noComment = false;
          } // endif
        },
        (error) => {
          console.error("Le Webservice getComment a renvoyé l'erreur suivante : ", error);
        }
      ); // fin de la récupération du user et des commentaires
    },
    
    autoGet: function() {
      console.log("Auto GET Comments");
      this.getComments();
    },
  
    /**
     * @description récupération des likes par webservice
     * @version 0.2
     */
    getLikes: function() {
      let _this = this; // utilis si la méthode est appelée depuis un hook
      // récupération des likes
      _this.webService(this.config.urlWebServices + 'getLikes').then(
        function (response) {
          let jdata = $.parseJSON(response.d);
  
          // console.dir(jdata);
  
          if (jdata.Data === null || _.isEmpty(jdata.Data)) {
            console.info("Pas de likes");
          } else {
            console.info("Y'a des likes");
            let wsData = $.parseJSON(jdata.Data);
            _this.page.likes = wsData.Likes;
            
            let like = _.findIndex(_this.page.likes, ['idUser', _this.user.idUser]); // l'utilisateur a-t-il liké ?
  
            _this.user.liked = like >= 0 ? true : false;
  
            _this.page.isLikesLoaded = true;
          } // endif
        },
        function(error) {
          console.error("Le Webservice getLikes à renvoyé l'erreur suivante : ", error);
        }
      ); // fin récupération des likes
    },
  
    /**
     * @description gestion du bouton like
     * @version 1.9
     */
    toggleLike: function() {
      if(this.user.isIdentified) {
        console.log("Like !!");
        let token = _.maxBy(this.page.likes, (o) => {
          return o.id;
        });
        const // pour calculer le point d'insertion dans le store de l'application
          idUser = this.user.idUser,
          like = _.findIndex(this.page.likes, ['idUser', idUser]); // l'utilisateur a-t-il liké ?
  
        if (like === -1) { // la personne aime la page
          console.info("Like +1");
          token = _.isUndefined(token) ? 0 : token.id;
          this.$set(this.page.likes, this.page.likes.length, {id: token + 1, idUser: idUser});
          this.user.liked = true;
    
          this.webService(this.config.urlWebServices + 'toggleLike').then(
            (response) => {
              console.log("Page likée ", response);
            },
            (error) => {
              console.error("Le Webservice toggleLike a renvoyé l'erreur suivante : ", error);
            }
          );
    
        }
        else { // la personne n'aime plus la page
          console.info("Like -1");
          // debugger;
          this.$delete(this.page.likes, like);
          this.user.liked = false;
    
          this.webService(this.config.urlWebServices + 'toggleLike').then(
            (response) => {
              console.log("Page délikée ", response);
            },
            (error) => {
              console.error("Le Webservice toggleLike a renvoyé l'erreur suivante : ", error);
            }
          );
        } // endif
      }// endif
    }, // fin  methode toggleLike
  
    /**
     * @description Effacement d'un commentaire
     * @param commentDeletedId
     * @version 1.1
     */
    delComment: function (commentDeletedId) {
      console.log("Effacement commentaire :", commentDeletedId);
      // on retire le commentaire de la collection pour un rendu immédiat
      // this.page.commentaires = this.page.commentaires.filter((el) => {
      //  return el.IdCommentaire !== commentDeletedId;
      // });

      //this.$delete(this.commentaires, delC);
  
      const param = `{idCommentaire: ${commentDeletedId}}`;
      // on envois l'effacement du commentaire au serveur
      
      this.webService(this.config.urlWebServices + 'delComment', param).then(
        (response) => {
          console.info("l'effacement du commentaire s'est bien déroulée.", response);
          // this.page.isCommentsLoaded = false;
          this.getComments();
        },
        (error) => {
          console.error("Le Webservice delComment à renvoyé l'erreur suivante : ", error);
        }
      )
    }, // fin methode delComment
  
    /**
     * @description récupère l'édition d'un commentaire (nouveau ou commentaire existant)
     * @version 1.6
     */
    addComment: function () {
      if (this.user.isEdit) {  // edition d'un commentaire existant
        const edited = {
          idCommentaire: this.user.editId,
          body: this.user.userComment
        };
  
        this.page.commentaires[this.user.localId].Body = edited.body;
  
        const param = JSON.stringify(edited);
  
        console.log(param);
        
        this.webService(this.config.urlWebServices + "updateComment", param).then(
          (response) => {
            console.log("l'insertion du commentaire s'est bien déroulée", response);
            this.cancelEdit();
          },
          (error) => {
            console.error("Le Webservice addComment à renvoyé l'erreur suivante : ", error);
          }
        );
      } else {  // insertion d'un nouveau commentaire
        const newComment = {
          "NameUserMAJ": this.user.nom,
          "IdUserMAJ": this.user.idUser,
          "Body": this.user.userComment,
          "DateMAJ": moment().format("DD/MM/YYYY HH:mm:ss")
        };
  
        console.log(newComment);
        // this.page.commentaires.unshift(newComment);
        this.user.userComment = "";
        $('.commentaire__form').removeClass('hero');
        //this.$set(this.commentaires, 0, newComment)
  
        const comment = JSON.stringify(newComment.Body);
        const jComment = `{body: ${comment}}`;
  
        this.webService(this.config.urlWebServices + "addComment", jComment).then(
          (response) => {
            console.log("l'insertion du commentaire s'est bien déroulée", response);
            this.getComments(); // récupération des commentaires
          },
          (error) => {
            console.error("Le Webservice addComment à renvoyé l'erreur suivante : ", error);
          }
        )
      } // endif
    }, // fin methode addComment
  
    /**
     * @description travail préparatoire à l'édition d'un commentaire
     * @param idComment
     * @version 1.2
     */
    editComment: function (idComment) {
      const indexInStateCommentaire = _.findIndex(this.page.commentaires, ['IdCommentaire', idComment]);
      const editedComment = this.page.commentaires[indexInStateCommentaire].Body;
  
      $(window).scrollTop($('#commentaire').offset().top - 50);
      $('.commentaire__form').addClass('hero');
      
      console.log("Edition commentaire :", editedComment);
      
      this.user.userComment = editedComment;
      this.user.isEdit = true;
      this.user.editId = idComment;
      this.user.localId = indexInStateCommentaire;
    } // fin methode editComment
  }, // fin des méthodes de l'application

  //=====================
  // Valeurs calculées
  //=====================
  computed: {
    /**
     * @description compte le nombre de commentaire dans le state
     * @return {number}
     * @version 0.1
     */
    nb_commentaires: function()  { // calcul le nb de commentaire
      const nbComments = this.page.commentaires.length;
  
      nbComments >= 1 ? this.page.hasCommentaires = true : this.page.hasCommentaires = false;
      
      return nbComments;
    },
  
    /**
     * @description vérifie si le champ de saisi du commentaire est vide
     * @return {boolean}
     * @version 0.1
     */
    notEmpty: function() {
      return this.user.userComment.trim().length === 0 ? true : false;
    },
  
    /**
     * @description compte le nombre de likes
     * @return {number}
     * @version 0.1
     */
    nb_likes: function() {
      const nbLikes = this.page.likes.length;
  
      return nbLikes;
    },
  
    /**
     * @description calcul la longueur d'un commentaire en cour de saisie
     * @return {number}
     * @version 0.1
     */
    commentLength: function() {
      return this.user.userComment.length;
    }
  }, // fin des computed de l'application
  
  
  /**
   * @description hook de montage du module commentaire
   * @version 1.5
   */
  beforeMount() {
    const self = this; // indispensable sinon this n'a pas la bonne portée
  
    self.page.showCommentModule = window.SHOWCOMMENTS;
  
    if(self.page.showCommentModule ) {
      self.getComments();
      self.getLikes();
    } else {
      console.info('Les commentaires ne sont pas activés sur cette page')
    }
    
  }, // fin beforemount()
  
  /**
   * @description hook de chargement automatique des commentaires
   * @version 0.1
   * note: désactivé pour l'instant
   */
  // mounted() {
  //   let autoComment;
  //   const _this = this;
  //
  //   autoComment = window.setTimeout(_this.autoGet(), 5000);
  // }
}); // fin de l'application